"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const signalsKinds_1 = require("../../../data/constants/signalsKinds");
const Spectrum1D_1 = require("../../../data/data1d/Spectrum1D");
const DispatchContext_1 = require("../../context/DispatchContext");
const EditableColumn_1 = __importDefault(require("../../elements/EditableColumn"));
const ReactTable_1 = __importDefault(require("../../elements/ReactTable/ReactTable"));
const addCustomColumn_1 = __importStar(require("../../elements/ReactTable/utility/addCustomColumn"));
const Select_1 = __importDefault(require("../../elements/Select"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const formatNumber_1 = require("../../utility/formatNumber");
const NoTableData_1 = __importDefault(require("../extra/placeholder/NoTableData"));
const NoDataForFid_1 = __importDefault(require("../extra/placeholder/NoDataForFid"));
const selectStyle = { width: '100%', border: 'none' };
function IntegralTable({ activeTab, data, info }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const deleteIntegralHandler = (0, react_1.useCallback)((row) => {
        const { id } = row.original;
        dispatch({
            type: 'DELETE_INTEGRAL',
            payload: {
                id,
            },
        });
    }, [dispatch]);
    const changeIntegralDataHandler = (0, react_1.useCallback)((value, row) => {
        const integral = { ...row.original, kind: value };
        dispatch({
            type: 'CHANGE_INTEGRAL',
            payload: { integral },
        });
    }, [dispatch]);
    const saveRelativeHandler = (0, react_1.useCallback)((event, row) => {
        dispatch({
            type: 'CHANGE_INTEGRAL_RELATIVE',
            payload: { value: event.target.value, id: row.id },
        });
    }, [dispatch]);
    const integralsPreferences = (0, usePanelPreferences_1.usePanelPreferences)('integrals', activeTab);
    const COLUMNS = (0, react_1.useMemo)(() => [
        {
            showWhen: 'showSerialNumber',
            index: 1,
            Header: '#',
            accessor: (_, index) => index + 1,
            style: { width: '30px', maxWidth: '30px' },
        },
        {
            showWhen: 'from.show',
            index: 2,
            Header: 'From',
            sortType: 'basic',
            accessor: (row) => (0, formatNumber_1.formatNumber)(row.from, integralsPreferences.from.format),
        },
        {
            showWhen: 'to.show',
            index: 3,
            Header: 'To',
            sortType: 'basic',
            accessor: (row) => (0, formatNumber_1.formatNumber)(row.to, integralsPreferences.to.format),
        },
        {
            showWhen: 'absolute.show',
            index: 4,
            Header: 'Absolute',
            accessor: (row) => (0, formatNumber_1.formatNumber)(row.absolute, integralsPreferences.absolute.format),
        },
        {
            showWhen: 'relative.show',
            index: 5,
            id: 'relative',
            Header: () => {
                const n = activeTab?.replace(/\d/g, '');
                return (0, jsx_runtime_1.jsx)("span", { children: `Relative ${n}` });
            },
            accessor: 'integral',
            Cell: ({ row }) => {
                const value = (0, formatNumber_1.formatNumber)(row.original.integral || 0, integralsPreferences.relative.format);
                const flag = (0, Spectrum1D_1.checkIntegralKind)(row.original);
                const integral = flag ? value : `[ ${value} ]`;
                return ((0, jsx_runtime_1.jsx)(EditableColumn_1.default, { value: integral, onSave: (event) => saveRelativeHandler(event, row.original), type: "number", validate: (val) => val !== '' }, `${integral}`));
            },
        },
        {
            index: 6,
            Header: 'Kind',
            sortType: 'basic',
            resizable: true,
            accessor: 'kind',
            showWhen: 'showKind',
            Cell: ({ row }) => ((0, jsx_runtime_1.jsx)(Select_1.default, { onChange: (value) => changeIntegralDataHandler(value, row), items: signalsKinds_1.SIGNAL_KINDS, style: selectStyle, defaultValue: row.original.kind })),
        },
        {
            showWhen: 'showDeleteAction',
            ...(0, addCustomColumn_1.createActionColumn)({
                index: 20,
                icon: (0, jsx_runtime_1.jsx)(fa_1.FaRegTrashAlt, {}),
                onClick: deleteIntegralHandler,
            }),
        },
    ], [
        activeTab,
        changeIntegralDataHandler,
        integralsPreferences,
        saveRelativeHandler,
        deleteIntegralHandler,
    ]);
    const tableColumns = (0, react_1.useMemo)(() => {
        const columns = [];
        for (const col of COLUMNS) {
            const { showWhen, ...colParams } = col;
            if ((0, get_1.default)(integralsPreferences, showWhen)) {
                (0, addCustomColumn_1.default)(columns, colParams);
            }
        }
        return columns.sort((object1, object2) => object1.index - object2.index);
    }, [COLUMNS, integralsPreferences]);
    if (info?.isFid) {
        return (0, jsx_runtime_1.jsx)(NoDataForFid_1.default, {});
    }
    if (!data || data.length === 0) {
        return (0, jsx_runtime_1.jsx)(NoTableData_1.default, {});
    }
    return (0, jsx_runtime_1.jsx)(ReactTable_1.default, { data: data, columns: tableColumns });
}
exports.default = (0, react_1.memo)(IntegralTable);
